<template>
  <div class="custom-list">
    <v-row no-gutters class="ma-0">
      <v-col cols="12" class="text-left pa-0">
        <v-card elevation="0" class="rounded-lg w-100 pa-4">
          <span
            class="text-h5 text-uppercase font-weight-bold text_color--text"
          >
            {{ tripPlanningModule.plan }} My {{ tripModule.trip }}
          </span>
        </v-card>
      </v-col>
      <v-col cols="12" class="mt-4 px-4">
        <v-card elevation="0" class="pa-4 rounded-lg">
          <v-form
            v-if="permissions && permissions.add"
            v-model="isValid"
            ref="tripPlanForm"
            @submit.prevent="submitForm"
          >
            <v-row class="ma-0 py-4" no-gutters>
              <v-col class="pr-2">
                <InputField
                  id="plan_name"
                  name="plan_name"
                  v-model="tripPlanningForm.plan_name"
                  :label="`${tripPlanningModule.plan} name`"
                  dense
                  hide-details="auto"
                  :required="true"
                  :error-messages="formErrors.plan_name"
                  @input="delete formErrors.plan_name"
                />
              </v-col>
              <v-col class="pr-2">
                <SelectField
                  id="project"
                  :itemsList="projectList"
                  :label="`Project *`"
                  name="order_segment"
                  :rules="[(val) => !!val || `Project is required`]"
                  itemText="name"
                  itemValue="id"
                  v-model="tripPlanningForm.project"
                  :error-messages="formErrors.project"
                />
              </v-col>
              <v-col class="pr-2">
                <SelectField
                  id="order_segment"
                  :itemsList="orderSegment"
                  :label="`${orderModule.order} Segment *`"
                  name="order_segment"
                  :rules="[
                    (val) =>
                      !!val || `${orderModule.order} Segment is required`,
                  ]"
                  itemText="display_value"
                  itemValue="value"
                  v-model="tripPlanningForm.order_segment"
                  :error-messages="formErrors.order_segment"
                />
              </v-col>
              <v-col class="pr-2">
                <DatePicker
                  id="plan_date"
                  name="plan_date"
                  type="date"
                  v-model="tripPlanningForm.plan_date"
                  :label="`${tripPlanningModule.plan} date *`"
                  dense
                  outlined
                  clearable
                  hide-details="auto"
                  :min="returnToday()"
                  :rules="[
                    (val) =>
                      !!val || `${tripPlanningModule.plan} date is required`,
                  ]"
                  :error-messages="formErrors.plan_date"
                />
              </v-col>
              <v-col class="pr-2">
                <SelectField
                  id="planning_templates"
                  name="planning_templates"
                  v-model="tripPlanningForm.planning_template"
                  dense
                  hide-details="auto"
                  :label="`${tripPlanningModule.planningTemplatePlural} *`"
                  itemText="name"
                  itemValue="id"
                  :itemsList="templateList"
                  :rules="[
                    (val) =>
                      !!val ||
                      `${tripPlanningModule.planningTemplate} is required`,
                  ]"
                  :error-messages="formErrors.planning_template"
                />
              </v-col>
              <v-col>
                <SelectField
                  id="drivers"
                  name="drivers"
                  v-model="tripPlanningForm.drivers"
                  :label="`${fleetModule.driverPlural} *`"
                  dense
                  hide-details="auto"
                  itemText="name"
                  itemValue="id"
                  :multiple="true"
                  :itemsList="driverList"
                  :rules="[
                    (val) =>
                      (val && val.length > 0) ||
                      `${fleetModule.driverPlural} are required`,
                  ]"
                  :error-messages="formErrors.drivers"
                  @change="delete formErrors.drivers"
                />
              </v-col>
              <v-col
                cols="6"
                md="2"
                class="d-flex justify-end align-center pl-2"
              >
                <SecondaryButton
                  id="driversReset"
                  text
                  btnClass="text-uppercase mr-2 rounded-lg"
                  name="Reset"
                  @click="resetForm()"
                />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">
                    <div v-on="{ ...tooltip }">
                      <PrimaryButton
                        id="planMyTripSubmit"
                        @click="submitForm"
                        :disabled="isButtonDisabled || !isValid"
                        name="Submit"
                        btnClass="text-uppercase rounded-lg"
                      >
                      </PrimaryButton>
                    </div>
                  </template>
                  {{ buttonTooltip }}
                </v-tooltip>
              </v-col>
            </v-row>
          </v-form>

          <v-row no-gutters>
            <v-col cols="12">
              <v-row no-gutters class="ma-0">
                <v-col cols="9" class="py-0 ma-0 d-flex align-center pt-4">
                  <v-row no-gutters>
                    <v-col cols="6">
                      <v-tabs v-model="currentTab" color="secondary">
                        <v-tab>{{ tripPlanningModule.recentPlanPlural }}</v-tab>
                        <v-tab v-if="orderList.length > 0"
                          >{{ orderModule.order }} List</v-tab
                        >
                      </v-tabs>
                      <!-- <span class="text-h6 font-weight-bold"> Recent Plans </span> -->
                    </v-col>
                    <v-col cols="6" class="d-flex justify-end align-center">
                      <TripPlanningFilter
                        id="planMyTripFilter"
                        v-if="currentTab == 0"
                        :filterObject="tripPlanningFilters"
                        :isChips="Object.keys(tripPlanningFilters).length > 0"
                        @apply="
                          pageNo = 1;
                          totalOrders = 0;
                          totalPlans = 0;
                          getList();
                        "
                        @reset="resetFilter"
                      />
                      <RefreshListButton
                        id="planMyTripRefreshList"
                        newClass="mr-2"
                        :isIcon="false"
                        @click="getList()"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="3"
                  class="py-0 ma-0 d-flex align-center pt-4 app-search-input"
                >
                  <InputField
                    id="search"
                    name="search"
                    label="Search"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    v-model="search"
                    background-color="background_color"
                    clearable
                    @keydown.enter="searchTriggered"
                    @click:clear="clearSearch"
                  ></InputField>
                  <v-btn
                    :id="`${tripPlanningModule.plan} My ${tripModule.trip} Search`"
                    x-small
                    fab
                    depressed
                    color="primary"
                    class="ml-1 rounded-lg btn-list-small"
                    @click="searchTriggered"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="pt-8">
              <v-data-table
                :headers="tableHeaders"
                :items="tableData"
                height="calc(100vh - 415px)"
                fixed-header
                hide-default-footer
                disable-pagination
                :loading="tableLoading"
                class="elevation-0 ag-grid-override"
              >
                <template v-slot:item.warnings="{ item }">
                  <v-tooltip right max-width="200" color="error">
                    <template #activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="error"
                        v-if="item.warnings && item.warnings.length > 0"
                      >
                        mdi-information
                      </v-icon>
                    </template>
                    <p
                      v-for="(warning, i) in item.warnings"
                      :key="i"
                      class="pa-0"
                    >
                      {{ i + 1 }}. {{ warning }}
                    </p>
                  </v-tooltip>
                </template>
                <template v-slot:item.selection="{ item }">
                  <v-icon @click="toggleOrderSelection(item)">
                    mdi-{{
                      excludeOrders.findIndex((id) => id == item.id) == -1
                        ? "checkbox-marked"
                        : "checkbox-blank-outline"
                    }}
                  </v-icon>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip top>
                    <template #activator="{ on, attrs }">
                      <SecondaryButton
                        :id="`${tripPlanningModule.plan} My ${tripModule.trip} View`"
                        v-if="permissions.view"
                        x-small
                        v-on="on"
                        v-bind="attrs"
                        btnClass="mr-2 rounded"
                        icon="mdi-eye"
                        iconClass=""
                        @click="
                          $router.push({
                            name: 'trip-plan-details',
                            params: { id: item.id },
                          })
                        "
                      >
                      </SecondaryButton>
                    </template>
                    <span>View</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template #activator="{ on, attrs }">
                      <ErrorButton
                        id="planMyTripDelete"
                        v-if="permissions.delete"
                        x-small
                        v-on="on"
                        v-bind="attrs"
                        @click="deletePlan(item)"
                        btnClass="mr-2 rounded"
                        icon="mdi-delete"
                        iconClass=""
                      >
                      </ErrorButton>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template #activator="{ on, attrs }">
                      <PrimaryButton
                        id="planMyTripInformation"
                        v-if="permissions.view"
                        x-small
                        v-on="on"
                        v-bind="attrs"
                        btnClass="mr-2 rounded"
                        icon="mdi-information"
                        iconClass=""
                        @click="openPlanInformationDialog(item.id)"
                      />
                    </template>
                    <span>Information</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template #activator="{ on, attrs }">
                      <SecondaryButton
                        v-show="
                          permissions.view &&
                          (item.status == 'Completed' ||
                            item.status == 'Failed')
                        "
                        id="planMyTripInformation"
                        x-small
                        v-on="on"
                        v-bind="attrs"
                        outlined
                        btnClass="mr-2 rounded"
                        icon="mdi-restart"
                        iconClass=""
                        iconColor="secondary"
                        @click="retryTripPlan(item)"
                      />
                    </template>
                    <span>{{
                      item.status == "Completed" ? "Replan" : "Retry"
                    }}</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="12">
              <Pagination
                :pageNo="pageNo"
                :totalItems="totalItems"
                :pageSize="itemsPerPage"
                @itemsPerPageChange="itemsPerPageChanged"
                @prevPage="prevPage"
                @nextPage="nextPage"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <PlanInfo v-model="openFailedInfoDialog" :planDetails="planInfo" />
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { returnToday } from "@/utils/functions";
import { bus } from "@/main";
import PlanInfo from "@/components/ModuleBasedComponents/TripPlanning/PlanInfo.vue";
import TripPlanningFilter from "@/components/ModuleBasedComponents/TripPlanning/TripPlanningFilter.vue";
import RefreshListButton from "@/components/BaseComponents/RefreshListButton.vue";
import Pagination from "@/components/BaseComponents/Pagination.vue";
import { mapState } from "vuex";
import { filterModules } from "@/utils/fieldConstants";
import {
  tripPlanningModule,
  fleetModule,
  tripModule,
  orderModule,
} from "@/utils/moduleMapping";

export default {
  components: {
    PlanInfo,
    TripPlanningFilter,
    RefreshListButton,
    Pagination,
  },
  data() {
    return {
      orderSegment: [],
      projectList: [],
      tripModule,
      tripPlanningModule,
      fleetModule,
      orderModule,
      returnToday,
      permissions: this.$permissions.getPermission("trip_planning"),
      tripPlanList: [],
      totalPlans: 0,

      planningHeaders: [
        {
          text: "Plan Name",
          value: "plan_name",
          align: "start",
          sortable: false,
        },
        {
          text: "Created On",
          value: "created",
          align: "start",
          sortable: false,
        },
        {
          text: "Plan Date",
          value: "plan_date",
          align: "start",
          sortable: false,
        },
        {
          text: "Order Segment",
          value: "order_segment",
          align: "start",
          sortable: false,
          cellClass: "text-capitalize",
        },
        {
          text: "Planning Template",
          value: "planning_template",
          align: "start",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          align: "start",
          sortable: false,
        },
        {
          text: "Progress",
          value: "progress",
          align: "start",
          sortable: false,
        },
        {
          text: "Total Orders",
          value: "total_orders",
          align: "start",
          sortable: false,
        },
        {
          text: "Planned Orders",
          value: "planned_orders",
          align: "start",
          sortable: false,
        },
        {
          text: "Total Trips",
          value: "trips_count",
          align: "start",
          sortable: false,
        },
        {
          text: "Total Distance",
          value: "distance",
          align: "start",
          sortable: false,
        },
      ],
      orderHeaders: [
        {
          text: "#",
          value: "selection",
          align: "start",
          sortable: false,
        },
        {
          text: "Warning",
          value: "warnings",
          align: "start",
          sortable: false,
        },
        {
          text: "Reference Number",
          value: "reference_number",
          align: "start",
          sortable: false,
        },
        {
          text: "Customer Name",
          value: "customer_name",
          align: "start",
          sortable: false,
        },
        {
          text: "Order Type",
          value: "order_type",
          align: "start",
          sortable: false,
        },
        {
          text: "Processing Time",
          value: "processing_time",
          align: "start",
          sortable: false,
        },
        {
          text: "Contact Number",
          value: "contact_number",
          align: "start",
          sortable: false,
        },
        {
          text: "Address",
          value: "address",
          align: "start",
          sortable: false,
        },
      ],
      tripPlanningForm: {
        drivers: [],
      },

      formErrors: {},

      templateList: [],
      driverList: [],

      orderList: [],
      totalOrders: 0,

      excludeOrders: [],

      isValid: true,

      currentTab: null,
      selectedRows: [],

      pageNo: 1,
      itemsPerPage: 10,

      planInfo: null,
      openFailedInfoDialog: false,
      timeOut: null,

      isButtonDisabled: false,
      buttonTooltip: "Create Trip Plan",

      search: null,
      tableLoading: false,

      intervalTimer: null,

      paginationTimeout: null,
    };
  },
  computed: {
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
    totalItems() {
      if (this.currentTab == 0) {
        return this.totalPlans;
      } else {
        return this.totalOrders;
      }
    },
    context() {
      return { parentComponent: this };
    },
    tableHeaders() {
      if (this.currentTab == 1) {
        return this.orderHeaders;
      } else {
        return [
          ...this.planningHeaders,
          {
            text: "Actions",
            value: "actions",
            width: 250,
            sortable: false,
          },
        ];
      }
    },
    tableData() {
      if (this.currentTab == 1) {
        return this.orderList;
      } else {
        return this.tripPlanList;
      }
    },
    selectedBranch() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj.preferred_branch.id;
      } else {
        return null;
      }
    },
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
    ...mapState("userProfile", {
      tripPlanningFilters: (state) => state.trip_planning_filters,
    }),
    selectedProject() {
      return this.tripPlanningForm.project;
    },
    selectedOrderSegment() {
      return this.tripPlanningForm.order_segment;
    },
    selectedPlanningTemplate() {
      return this.tripPlanningForm.planning_template;
    },
    selectedPlanDate() {
      return this.tripPlanningForm.plan_date;
    },
  },
  watch: {
    selectedProject(val) {
      if (val) {
        delete this.formErrors.project;
        this.getOrderDriverPlanList();
      }
    },
    selectedOrderSegment(val) {
      if (val) {
        delete this.formErrors.order_segment;
        this.getOrderDriverPlanList();
      }
    },
    selectedPlanningTemplate(val) {
      if (val) {
        delete this.formErrors.planning_template;
        this.getOrderDriverPlanList();
      }
    },
    selectedPlanDate(val) {
      if (val) {
        delete this.formErrors.plan_date;
        this.getOrderDriverPlanList();
      }
    },
  },
  methods: {
    getTripPlanningOptions() {
      this.$api.tripPlanning
        .getTripPlanningOptions({ request_type: "form" })
        .then((res) => {
          this.orderSegment = res?.data?.order_segment;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    resetForm() {
      this.$refs.tripPlanForm.resetValidation();
      this.tripPlanningForm = {
        drivers: [],
      };
      this.orderList = [];
      this.excludeOrders = [];
    },
    retryTripPlan(plan) {
      let action = plan.status == "Completed" ? "replan" : "retry";
      this.$root
        .$confirm(
          `${action.toUpperCase()}?`,
          `Are you sure you want to ${action} plan "${plan.plan_name}" ?`,
          { color: "secondary" }
        )
        .then((consent) => {
          if (consent) {
            bus.$emit("showLoader", true);
            this.$api.tripPlanning
              .retryTripPlan(plan.id)
              .then(() => {
                bus.$emit("showLoader", false);
                this.pageNo = 1;
                this.totalOrders = 0;
                this.totalPlans = 0;
                this.getList();
              })
              .catch((err) => {
                console.log(err);
                bus.$emit("showLoader", false);
              });
          }
        });
    },
    toggleOrderSelection(order) {
      let orderIndex = this.excludeOrders.findIndex((id) => id == order.id);
      if (~orderIndex) {
        this.excludeOrders.splice(orderIndex, 1);
      } else {
        this.excludeOrders.push(order.id);
      }
    },
    checkSubscriptionLimit() {
      this.$api.company
        .checkSubscriptionLimit(this.profileObject.company, {
          module: "tripplan",
        })
        .then(() => {
          this.isButtonDisabled = false;
          return true;
        })
        .catch((err) => {
          bus.$emit("showToastMessage", {
            message: err.data.non_field_errors[0],
            color: "error",
            timeout: 4000,
          });
          this.isButtonDisabled = true;
          this.buttonTooltip = err.data.non_field_errors[0];
          return false;
        });
    },
    searchTriggered() {
      if (this.search) {
        this.search = this.search.trim();
        this.itemsPerPageChanged(this.itemsPerPage);
      }
    },
    clearSearch() {
      this.search = null;
      this.itemsPerPageChanged(this.itemsPerPage);
    },
    getList(params) {
      params = {
        ...params,
        offset: this.offset,
        limit: this.itemsPerPage,
      };
      if (this.currentTab == 0) {
        this.getTripPlanList(params);
      } else {
        this.getTripPlanningOrderList(params);
      }
    },
    resetFilter() {
      this.$store.commit("userProfile/resetFilters", {
        moduleKey: "trip_planning_filters",
      });
      this.pageNo = 1;
      this.totalOrders = 0;
      this.totalPlans = 0;
      this.getList();
    },
    openPlanInformationDialog(id) {
      this.$api.tripPlanning
        .getTripPlanInfo(id)
        .then((res) => {
          this.planInfo = { ...res.data, id: id };
          this.openFailedInfoDialog = true;
        })
        .catch(() => {
          bus.$emit("showToastMessage", {
            message: "Couldn't fetch data!",
            color: "error",
          });
        });
    },
    deletePlan(plan) {
      this.$root
        .$confirm(
          "Delete?",
          `Are you sure you want to delete plan ${plan.plan_name} ?`,
          { color: "error" }
        )
        .then((confirm) => {
          if (confirm) {
            this.$api.tripPlanning
              .deleteTripPlanningObject(plan.id)
              .then(() => {
                bus.$emit("showLoader", false);
                this.getList();
              })
              .catch((err) => {
                console.error(err);
                bus.$emit("showLoader", false);
              });
          }
        });
    },
    submitForm() {
      if (!this.$refs.tripPlanForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      let orderIdsToExclude = [...this.excludeOrders];
      bus.$emit("showLoader", true);
      let payload = {
        branch: this.selectedBranch,
        ...this.tripPlanningForm,
        orders: orderIdsToExclude,
      };
      this.$api.tripPlanning
        .createTripPlanningObject(payload)
        .then(() => {
          this.tripPlanningForm = {
            drivers: [],
          };
          this.orderList = [];
          this.excludeOrders = [];
          this.currentTab = 0;
          this.getList();
          this.$refs.tripPlanForm.reset();
          this.resetForm();
          bus.$emit("showLoader", false);
          this.checkSubscriptionLimit();
        })
        .catch((err) => {
          this.formErrors = err.data;
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getOrderDriverPlanList() {
      if (
        this.tripPlanningForm.plan_date &&
        this.tripPlanningForm.planning_template &&
        this.tripPlanningForm.order_segment &&
        this.tripPlanningForm.project
      ) {
        this.getTripPlanningOrderList({ limit: 10, offset: 0 });
        this.getTripPlanningDriverList();
      }
    },
    getTripPlanningOrderList(params) {
      this.tableLoading = true;
      params = {
        ...params,
        branch: this.selectedBranch,
        plan_date: this.tripPlanningForm.plan_date,
        order_segment: this.tripPlanningForm.order_segment,
        planning_template: this.tripPlanningForm.planning_template,
        project: this.tripPlanningForm.project,
      };
      this.$api.tripPlanning
        .getTripPlanOrderList(params)
        .then((res) => {
          this.orderList = res.data;
          this.totalOrders = res.count;
          if (this.orderList.length > 0) {
            this.currentTab = 1;
          } else {
            bus.$emit("showToastMessage", {
              message: "No orders found for selected date & template!",
              color: "error",
              timeout: 3000,
            });
          }
          this.tableLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.tableLoading = false;
        });
    },
    getProjectSelectList(id) {
      if (id) {
        this.$api.project
          .getProjectSelectList({ limit: "all", branch: id })
          .then((res) => {
            this.projectList = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.projectList = [];
      }
    },
    getTripPlanningDriverList(params) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        branch: this.selectedBranch,
        plan_date: this.tripPlanningForm.plan_date,
        planning_template: this.tripPlanningForm.planning_template,
        project: this.tripPlanningForm.project,
        limit: "all",
      };

      this.$api.tripPlanning
        .getTripPlanDriverList(params)
        .then((res) => {
          this.driverList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    async getTripPlanList(params = {}) {
      this.tableLoading = true;
      params = {
        ...params,
        ...this.tripPlanningFilters,
      };

      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }

      if ("status" in params && params.status.length > 0) {
        params = { ...params, status: params.status.join(",") };
      }

      if (this.search) {
        params.search = this.search;
      }

      await this.$store.dispatch("userProfile/updateUserFilters", {
        filter_data: { ...this.tripPlanningFilters },
        filter_type: filterModules.TRIP_PLANNING,
      });

      this.$api.tripPlanning
        .getTripPlanningList(params)
        .then((res) => {
          this.tripPlanList = res.data;
          this.totalPlans = res.count;
          this.tableLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.tableLoading = false;
        });
    },
    getTripPlanningTemplateList(params = {}) {
      params = {
        ...params,
        limit: "all",
        branch: this.selectedBranch,
      };
      bus.$emit("showLoader", true);
      this.$api.tripPlanningTemplate
        .getTripPlanningTemplateList(params)
        .then((res) => {
          this.templateList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    itemsPerPageChanged(e) {
      this.pageNo = 1;
      this.itemsPerPage = e;
      this.getList();
    },
    prevPage() {
      this.pageNo--;
      if (this.paginationTimeout) {
        clearTimeout(this.paginationTimeout);
      }

      this.paginationTimeout = setTimeout(() => {
        this.getList();
      }, 500);
    },
    nextPage() {
      this.pageNo++;
      if (this.paginationTimeout) {
        clearTimeout(this.paginationTimeout);
      }

      this.paginationTimeout = setTimeout(() => {
        this.getList();
      }, 500);
    },
  },
  mounted() {
    this.permissions = this.$permissions.getPermission("trip_planning");
    this.getTripPlanningOptions();
    this.getTripPlanningTemplateList();
    this.getProjectSelectList(this.selectedBranch);
    this.itemsPerPageChanged(this.itemsPerPage);
    this.intervalTimer = setInterval(() => {
      this.getList();
    }, 30000);
  },
  created() {
    this.checkSubscriptionLimit();
  },
  beforeDestroy() {
    this.tripPlanningForm = {
      drivers: [],
    };
    clearInterval(this.intervalTimer);
  },
};
</script>

<style lang="scss">
.ag-grid-override {
  border: 0px !important;
  border-radius: 10px !important;
  box-shadow: 0px 0px 3px 3px rgb(0 0 0 / 4%);
}
.ag-grid-override.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 0.875rem !important;
  font-weight: 700;
  line-height: 1.25rem;
  letter-spacing: 0.0178571429em !important;
  font-family: "Roboto", sans-serif !important;
  color: black;
  background-color: #f8f8f8;
}
.ag-grid-override {
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    letter-spacing: 0.31px;
  }
}
.app-search-input {
  input {
    max-height: 34px;
  }
  .v-text-field--outlined fieldset {
    border-width: 0px !important;
  }
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
    > .v-input__control
    > .v-input__slot {
    min-height: 34px;
  }
  .v-text-field--outlined.v-input--dense .v-label {
    top: 8px;
    font-size: 12px;
  }
}

.app-search-input-white {
  input {
    max-height: 34px;
  }

  .v-text-field--outlined.v-input--dense.v-text-field--outlined
    > .v-input__control
    > .v-input__slot {
    min-height: 34px;
  }
  .v-text-field--outlined.v-input--dense .v-label {
    top: 8px;
    font-size: 12px;
  }
}
</style>
